import { inject } from '@angular/core';
import { CanMatchFn } from '@angular/router';
import { isQuotationSignEnabled } from '@web/core/helpers/is-quotation-sign-enabled.helper';
import { CONFIG } from '@web/core/injection-tokens/config.token';

export const canMatchQuotationSign: CanMatchFn = () => isQuotationSignEnabled(inject(CONFIG));
